import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'masterdata/printTranslation';

const printTranslationService = {
  getData: (resourceCode, recordKey) =>
    request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data: { resourceCode, recordKey: String(recordKey) },
    }),

  create: (data) =>
    request({
      method: Methods.POST,
      resource: baseURL,
      data,
    }),

  update: (data) =>
    request({
      method: Methods.PUT,
      resource: baseURL,
      data,
    }),

  delete: (id) =>
    request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    }),
};

export default printTranslationService;
